export default __webpack_public_path__ + "static/media/user-icon.d50c1e2a.png";